import { PayloadAction } from '@reduxjs/toolkit';
import { ITutorialContent } from '@/store/types';
import { createSliceSteamup } from '../common';

interface ITutorialState {
  loading: boolean;
  list: ITutorialContent[];
  filter: {
    q: string;
  }
}

const tutorialSlice = createSliceSteamup(
  'tutorial',
  {
    loading: true,
    list: [],
    filter: {
      q: '',
      // 필터도 여기 추가?
    },
  } as ITutorialState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setQ(state, { payload }: PayloadAction<(typeof state.filter.q)>) {
      state.filter.q = payload;
    },
    setReset(state) {
      state.filter.q = '';
    },
  },
);

export default tutorialSlice;
